import { UsersFilter } from '../models';
import { useGetUsersQuery } from '../services';

interface UseUserProps {
  filters?: UsersFilter;
  paginated: {
    page: number;
    pageSize: number;
  };
}

const useUsers = ({ filters, paginated }: UseUserProps) => {
  const {
    data: users,
    isLoading,
    isFetching,
    error,
  } = useGetUsersQuery({ filters: filters || {}, paginated });

  return {
    users: users?.items || [],
    totalItems: users?.count || 0,
    totalPages: users?.count ? Math.ceil(users.count / paginated.pageSize) : 0,
    isUsersLoading: isLoading || isFetching,
    error,
  };
};

export default useUsers;
